import React from "react";
import Input from "../../../../reusable-components/inputs/InputTextBox/Input";
import SubmitButton from "../../../../reusable-components/buttons/SubmitButton";
import Button from "../../../../reusable-components/buttons/Button";
import { useForm } from "react-hook-form";
import { button, cancel_button } from "../../../../theme/lightTheme";
import { MST_CASHCOUNTER_CONFIG_URL } from "../../../../api/api_routing_urls";
import showToast from "../../../../utilities/notification/NotificationModal";
import useAuth from "../../../../authentication/hooks/useAuth";
import useAxiosPrivate from "../../../../authentication/hooks/useAxiosPrivate";

export default function AddCashCounter({
  setShowAddForm,
  getCashCounterList,
  editCashCounterDetails,
  setEditCashCounterDetails,
}) {
  const { auth } = useAuth();
  const axiosPrivate = useAxiosPrivate();
  const controller = new AbortController();

  let isEdit =
    editCashCounterDetails === undefined || editCashCounterDetails === null
      ? false
      : Object?.keys(editCashCounterDetails)?.length > 0
      ? true
      : false;

  const defaultValues = {
    expense_name: !isEdit ? "" : editCashCounterDetails?.expense_name,
  };

  const {
    register,
    handleSubmit,
    formState: { errors, isSubmitting },
    setError,
    clearErrors,
    reset,
    setValue,
    control,
  } = useForm({
    mode: "onChange",
    defaultValues: defaultValues,
    criteriaMode: "all",
    shouldFocusError: true,
    shouldUnregister: true,
  });

  const onSubmit = async (data) => {
    try {
      let response = "";
      let sendDataObj = {};

      sendDataObj.expense_name = data.expense_name;
      if (!isEdit) {
        sendDataObj.created_by = auth.userid;

        response = await axiosPrivate.post(
          `${MST_CASHCOUNTER_CONFIG_URL}/saveCashCounterDetails`,
          sendDataObj,
          {
            signal: controller.signal,
          }
        );
      } else {
        sendDataObj.updated_by = auth.userid;
        sendDataObj.expense_id = editCashCounterDetails?.expense_id;

        response = await axiosPrivate.post(
          `${MST_CASHCOUNTER_CONFIG_URL}/updateCashCounterDetails`,
          sendDataObj,
          {
            signal: controller.signal,
          }
        );
      }
      if (response.status === 200) {
        if (isEdit) {
          showToast(
            "Expense Details  has been updated successfully",
            "success"
          );
        } else {
          showToast("Expense Details has been added successfully", "success");
        }
        getCashCounterList();
      } else {
        if (isEdit) {
          if (
            response.data.updateConstituencyDetails.includes(
              "unique_cashcounter"
            )
          ) {
            showToast(
              "Designation already exists. Cannot insert duplicate cash counter",
              "error"
            );
          } else {
            showToast(
              "Whoops!!!! This doesn't feel right. There might be an issue. Please contact administrator",
              "error"
            );
          }
        } else {
          if (
            response.data.saveCashCounterDetails.includes("unique_cashcounter")
          ) {
            showToast(
              "Designation already exists. Cannot insert duplicate cash counter",
              "error"
            );
          } else {
            showToast(
              "Whoops!!!! This doesn't feel right. There might be an issue. Please contact administrator",
              "error"
            );
          }
        }
        return;
      }
      setShowAddForm(false);
      reset();
    } catch (error) {
      console.error(error);
      if (!error?.response) {
        showToast("No Server Response", "error");
      } else if (error.response.status === 422) {
        showToast("Some of the required inputs were not provided", "error");
      } else {
        showToast(
          "Whoops!!!! This doesn't feel right. There might be an issue. Please contact administrator",
          "error"
        );
      }
    }
  };

  return (
    <>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Input
          defaultName="expense_name"
          register={register}
          name="Expense Name"
          required={true}
          pattern={null}
          errors={errors}
          placeholder="Enter Expense name"
          setError={setError}
          clearError={clearErrors}
          autoComplete="off"
          type="text"
          classes={`rounded-lg px-3 py-2 text-sm w-full`}
          onChangeInput={null}
          defaultValue={defaultValues.expense_name}
          setValue={setValue}
        />

        <div className="flex justify-between">
          <SubmitButton
            isSubmitting={isSubmitting}
            label={!isEdit ? "Submit" : "Update"}
            className={button}
          />
          <Button
            onClick={() => {
              setEditCashCounterDetails({});
              setValue("cashcounter_title_name", "");
              setShowAddForm(false);
            }}
            aria-label="Cancel Area Update Button"
            className={cancel_button}
          >
            Cancel
          </Button>
        </div>
      </form>
    </>
  );
}
